import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class MqttSignalService {
    componentSignal = signal<string | null>(null);

    constructor() {}

    setComponent(value: string | null) {
        this.componentSignal.set(value);
    }

    clear() {
        this.componentSignal.set(null);
    }
}
